import React from "react";

const Testimonials = () => {
  const testimonials = [
    {
      text: "इस प्लेटफ़ॉर्म की वजह से मेरी कमाई पहले से दोगुनी हो गई है। अब मुझे ज्यादा काम मिल रहा है और मेरा परिवार खुश है।",
      name: "शर्वन कुमार",
      designation: "फरीदाबाद, हरियाणा",
      image: "/assests/images/LandingPage/vendor/img-1.png",
    },
    {
      text: "पहले मुझे काम ढूंढने में दिक्कत होती थी, लेकिन अब यह प्लेटफ़ॉर्म मुझे हर दिन नए काम से जोड़ता है। इससे मेरी कमाई भी बढ़ गई है।",
      name: "कमलेश पांडेय",
      designation: "पंजाब, जालंधर",
      image: "/assests/images/LandingPage/vendor/img-2.png",
    },
    {
      text: "यह प्लेटफ़ॉर्म मेरे जैसे इंस्टॉलर्स के लिए बहुत फायदेमंद है। इससे मुझे नए मौके मिले हैं",
      name: "चाँद मोहम्मद",
      designation: "भोपाल, मध्य प्रदेश",
      image: "/assests/images/LandingPage/vendor/img-3.png",
    },
  ];

  return (
    <div className="bg-gray-100 py-16 px-6 md:px-16">
      <h3 className="text-center text-lg text-gray-500 uppercase tracking-wide mb-4">
        Testimonials
      </h3>
      <h2 className="text-center text-2xl font-bold mb-8">
        Encouraging Words From Installation Partners
      </h2>
      <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
        {testimonials.map((testimonial, index) => (
          <div
            key={index}
            className={`p-6 rounded-lg shadow-lg w-full max-w-sm md:max-w-md ${
              index === 1 ? "bg-gray-800 text-white" : "bg-white"
            }`}
          >
            <img 
              src="/assests/images/LandingPage/vendor/markIcon.png"
              alt="mark"
              className="w-4 h-4  mr-4 mb-4"
            />
            <p className="text-sm mb-6">{testimonial.text}</p>
            <div className="flex items-center">
              {/* <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-12 h-12 rounded-full mr-4"
              /> */}
              <div>
                <h4 className="font-bold text-sm">{testimonial.name}</h4>
                <p className="text-xs">{testimonial.designation}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
